import { StatusEnum } from '@plugins/octacornerstone-lib/enums';
import { LearningObjectChild } from '@plugins/octacornerstone-lib/types';

import { getLearningObjectType } from '../constants/training-types-map';
import { getTrainingMinutes } from '../utils/get-training-minutes';

export class TrainingChild implements LearningObjectChild {
  dueDate: string;
  itemSequence: number;
  loId: string;
  loTrainingHours: string;
  loType: string;
  parentLoId: string;
  status: string;
  title: string;

  constructor(data: LearningObjectChild) {
    Object.assign(this, data);
  }

  get pastDue() {
    return (
      this.status !== StatusEnum.COMPLETED &&
      this.dueDate &&
      new Date(this.dueDate) < new Date()
    );
  }

  get learningType() {
    return getLearningObjectType(this.loType);
  }

  get time(): string {
    const totalMinutes = getTrainingMinutes(this.loTrainingHours);
    if (totalMinutes === null) {
      return null;
    }

    if (totalMinutes < 0) {
      return this.loTrainingHours;
    }

    return totalMinutes >= 60
      ? Math.floor(totalMinutes / 60) + ' h ' + (totalMinutes % 60) + ' min'
      : totalMinutes + ' min';
  }

  get isCompleted(): boolean {
    return this.status === StatusEnum.COMPLETED;
  }
}
